const DECIMAL_REGEX = /^\d+(\.\d{1,2})?$/

const validateDecimalValue = value => DECIMAL_REGEX.test(value)

export default validateDecimalValue
